import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

import { ModalRoute } from "../Navigation/ModalRoute";
import { ModalTransitionSwitch } from "../Navigation/ModalTransitionSwitch";
import { ShiftDatePicker } from "../Shift/Calendar/ShiftDatePicker";
import { InAppAdDetailsBottomSheet } from "../Shift/InAppAd/DetailsBottomSheet";
import { WorkerPaySurveyBottomSheet } from "../WorkerPaySurvey/components/WorkerPaySurveyBottomSheet";
import { WorkerPaySurveySuccessBottomSheet } from "../WorkerPaySurvey/components/WorkerPaySurveySuccessBottomSheet";
import { ShiftDiscoveryFiltersBottomSheet } from "./Filters/BottomSheet/Sheet";
import { ShiftDiscoveryFiltersBottomSheetV2 } from "./Filters/BottomSheet/SheetV2";
import {
  SHIFT_DISCOVERY_CALENDAR_PATH,
  SHIFT_DISCOVERY_FILTERS_PATH,
  SHIFT_DISCOVERY_IN_APP_AD_MODAL_PATH,
  SHIFT_DISCOVERY_RECOMMENDED_PATH,
  SHIFT_DISCOVERY_WORKER_PAY_SURVEY_MODAL_PATH,
  SHIFT_DISCOVERY_WORKER_PAY_SURVEY_SUCCESS_MODAL_PATH,
} from "./paths";
import { ShiftRecommendationsPage } from "./ShiftRecommendationsView/Page";

interface CommonModalRoutesProps {
  baseNavigationPath: string;
}

export function CommonModalRoutes(props: CommonModalRoutesProps) {
  const { baseNavigationPath } = props;

  const isFiltersRedesignEnabled = useCbhFlag(CbhFeatureFlag.SHIFT_DISCOVERY_FILTERS_REDESIGN, {
    defaultValue: false,
  });

  return (
    <ModalTransitionSwitch>
      <ModalRoute
        closeModalPath={baseNavigationPath}
        path={`${baseNavigationPath}/${SHIFT_DISCOVERY_CALENDAR_PATH}`}
        render={({ modalState }) => <ShiftDatePicker modalState={modalState} />}
      />
      <ModalRoute
        closeModalPath={baseNavigationPath}
        path={`${baseNavigationPath}/${SHIFT_DISCOVERY_FILTERS_PATH}`}
        render={({ modalState }) => {
          if (isFiltersRedesignEnabled) {
            return <ShiftDiscoveryFiltersBottomSheetV2 modalState={modalState} />;
          }

          return <ShiftDiscoveryFiltersBottomSheet modalState={modalState} />;
        }}
      />
      <ModalRoute
        closeModalPath={baseNavigationPath}
        path={`${baseNavigationPath}/${SHIFT_DISCOVERY_IN_APP_AD_MODAL_PATH}`}
        render={({ modalState }) => <InAppAdDetailsBottomSheet modalState={modalState} />}
      />
      <ModalRoute
        closeModalPath={baseNavigationPath}
        path={`${baseNavigationPath}/${SHIFT_DISCOVERY_RECOMMENDED_PATH}`}
        render={({ modalState }) => <ShiftRecommendationsPage modalState={modalState} />}
      />
      <ModalRoute
        closeModalPath={baseNavigationPath}
        path={`${baseNavigationPath}/${SHIFT_DISCOVERY_WORKER_PAY_SURVEY_MODAL_PATH}`}
        render={({ modalState }) => <WorkerPaySurveyBottomSheet modalState={modalState} />}
      />
      <ModalRoute
        closeModalPath={baseNavigationPath}
        path={`${baseNavigationPath}/${SHIFT_DISCOVERY_WORKER_PAY_SURVEY_SUCCESS_MODAL_PATH}`}
        render={({ modalState }) => <WorkerPaySurveySuccessBottomSheet modalState={modalState} />}
      />
    </ModalTransitionSwitch>
  );
}
